import { render, staticRenderFns } from "./BlobItem.vue?vue&type=template&id=8c8f68e8&scoped=true&lang=pug"
import script from "./BlobItem.vue?vue&type=script&lang=js"
export * from "./BlobItem.vue?vue&type=script&lang=js"
import style0 from "./BlobItem.vue?vue&type=style&index=0&id=8c8f68e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8f68e8",
  null
  
)

export default component.exports